import React from "react";
import { MultiColumnList, TextLink } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export var TitleSupportingResourcesTable = function (_a) {
    var resources = _a.resources;
    return (React.createElement(MultiColumnList, { contentData: resources, columnMapping: {
            type: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.supportingResources.type.label" })),
            mode: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.supportingResources.mode.label" })),
            link: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.supportingResources.link.label" })),
        }, formatter: {
            type: function (item) { var _a; return ((_a = item.type) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
            mode: function (item) { var _a; return ((_a = item.mode) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
            link: function (item) {
                if (!item.link || item.link === "-")
                    return "-";
                return (React.createElement(TextLink, { href: item.link, target: "_blank", rel: "noopener noreferrer" }, item.link));
            },
        }, visibleColumns: ["type", "mode", "link"], isEmptyMessage: React.createElement(FormattedMessage, { id: "ui-br-agency.table.empty" }), interactive: false }));
};
